
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 487.724 487.724"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M236.925.124c-96.9 3.4-177.4 79-186.7 175.5-1.9 19.3-.8 38 2.6 55.9 0 0 .3 2.1 1.3 6.1 3 13.4 7.5 26.4 13.1 38.6 19.5 46.2 64.6 123.5 165.8 207.6 6.2 5.2 15.3 5.2 21.6 0 101.2-84 146.3-161.3 165.9-207.7 5.7-12.2 10.1-25.1 13.1-38.6.9-3.9 1.3-6.1 1.3-6.1 2.3-12 3.5-24.3 3.5-36.9 0-109.8-90.9-198.3-201.5-194.4zm6.9 291.2c-52.2 0-94.5-42.3-94.5-94.5s42.3-94.5 94.5-94.5 94.5 42.3 94.5 94.5-42.3 94.5-94.5 94.5z"}})])
          )
        }
      }
    